import { parseAsString, parseAsStringEnum, useQueryStates } from 'nuqs';
import { DataTablePageSizeEnum, PaymentMethodRequestStatusEnum } from '@/enums';
import { useQueryParams } from '@/hooks';

const useUrlParams = () => {

  const { values: [sortType, sortBy, limit, page] } = useQueryParams(
    ['sortType', 'sortBy', 'limit', 'page'],
    { limit: DataTablePageSizeEnum._50, page: 1 }
  );

  const [{ status, country }, setFilters] = useQueryStates({
    status: parseAsStringEnum<PaymentMethodRequestStatusEnum>(Object.values(PaymentMethodRequestStatusEnum)),
    country: parseAsString
  });

  return ({
    status: status ?? undefined,
    country: country ?? undefined,
    limit: limit as DataTablePageSizeEnum,
    setFilters,
    sortType,
    sortBy,
    page
  });

};

export default useUrlParams;
